import React from 'react';

import getRoleBasedPath from '../../helpers/getRoleBasedPath';

import { ProductCategoryLink } from '../../components/Links';
import {
  columnCreatedAt,
  columnUpdatedAt,
} from '../../components/common';

export const columnNameAdmin = {
  path: 'name',
  sort: 'name',
  width: '100%',
  link: '/categories/:_id',
};

export const columnNameSeller = {
  path: 'name',
  sort: 'name',
  width: '100%',
  link: '/store/categories/:_id',
};

export const columnStore = {
  title: 'Store',
  path: 'store.name',
  link: '/stores/:store._id',
};

export const columnProducts = {
  path: 'products',
  sort: 'products',
  render: (record, column, props) => (
    record.products > 0
    ? (
      <ProductCategoryLink
        location={props.location}
        subject={record}
        pathname={getRoleBasedPath(props, '/products')}
        valuePath="_id"
      >
        {`${record.products}`}
      </ProductCategoryLink>
    )
    : '0'
  ),
};

export const ADMIN = [
  columnNameAdmin,
  columnStore,
  columnProducts,
  columnCreatedAt,
  columnUpdatedAt,
];

export const SELLER = [
  columnNameSeller,
  columnProducts,
  columnCreatedAt,
  columnUpdatedAt,
];
